import React, { useEffect } from 'react'
import './EmpresaPage.scss'
import { DobleGuion } from '../components/DobleGuion'
import { scrollBodyTop } from '../hooks/scrollPosition'

export const EmpresaPage = () => {

    useEffect(() => {
        scrollBodyTop()
    }, [])

    return (
        <div className="empresa-page-container">
            <div className="header">
                <img className="movil" src="/static/img/header-quienes-somos-m.jpg" alt="" />
                <img className="tablet" src="/static/img/header-quienes-somos-t.jpg" alt="" />
                <img className="escritorio" src="/static/img/header-quienes-somos.jpg" alt="" />
            </div>
            <div className="empresa-page-content">
                <div className="empresa">
                    <div className="image">
                        <img className="movil" src="/static/img/img-empresa-m.jpg" alt="" />
                        <img className="tablet" src="/static/img/img-empresa-t.jpg" alt="" />
                        <img className="escritorio" src="/static/img/img-empresa.jpg" alt="" />
                    </div>
                    <div className="info">
                        <div className="titulo"><p>Empresa</p></div>
                        <div className="texto">
                            <p>
                                <strong>Fundada en 1959</strong> como <strong>fábrica industrial de macetas de barro</strong>, Fansa es hoy la empresa líder del mercado español y portugués. A día de hoy seguimos apostando por mantener nuestra posición de <strong>liderazgo en el mercado de macetas y jardineras</strong> para plantas y para ello tratamos de ampliar y mejorar constantemente nuestra gama de productos y servicios, así como nuestro conocimiento del mercado y nuestra cercanía a las necesidades de los clientes.
                            </p>
                            <p>
                                Fansa se unió al <strong>Grupo Deroma</strong> en 1998 y desde entonces somos la filial del grupo Deroma para los mercados español y portugués. En 2015 Fansa y la empresa alemana <strong>Scheurich</strong> firmaron un acuerdo de colaboración para desarrollar su marca y distribuir sus productos en España y Portugal. Scheurich es el fabricante europeo líder en maceteros de interior.
                            </p>
                        </div>
                    </div>
                </div>

                <div className="valores">
                    <div className="image">
                        <img className="movil" src="/static/img/img-valores-m.jpg" alt="" />
                        <img className="tablet" src="/static/img/img-valores-t.jpg" alt="" />
                        <img className="escritorio" src="/static/img/img-valores.jpg" alt="" />
                    </div>
                    <div className="info">
                        <div className="titulo"><p>Valores</p></div>
                        <div className="texto">
                            <p>
                                Creemos, especialmente en estos tiempos, que, además de los resultados económicos, hay otras cosas importantes. Creemos firmemente en las personas y en el valor presente y futuro de las relaciones que tratamos de construir con ellas. Por eso decidimos, hace algún tiempo, alcanzar nuestros objetivos no de cualquier manera, sino en base a algunos valores concretos que guían nuestro comportamiento, como la <strong>integridad moral, la responsabilidad social y un exigente código ético</strong> que se aplica a la fabricación de nuestros productos en cualquier lugar del mundo.
                            </p>
                            <p>
                                Hemos asumido el compromiso de fomentar la transición de una sociedad de "usar y tirar" a un modelo económico circular y sostenible. Nuestros nuevos productos reciclados están fabricados con materia prima <strong>proveniente de la recogida</strong> selectiva doméstica <strong>de residuos</strong>, ayudando a limitar el derroche de recursos y la generación de residuos.
                            </p>
                        </div>
                    </div>
                </div>

                <div className="servicios">
                    <div className="image">
                        <img className="movil" src="/static/img/img-servicios-m.jpg" alt="" />
                        <img className="tablet" src="/static/img/img-servicios-t.jpg" alt="" />
                        <img className="escritorio" src="/static/img/img-servicios.jpg" alt="" />
                    </div>
                    <div className="info">
                        <div className="titulo"><p>Servicios</p></div>
                        <div className="texto">
                            <p>Nuestros clientes son, prinipalmente, <strong>centros de jardinería, cadenas de bricolaje y de alimentación y floristerías</strong> en España y Portugal.</p>
                            <p>Estamos especialmente orgullosos de la confianza que nuestros clientes depositan en nosotros. Son ellos el foco principal de nuestra organización y <strong>ofrecerles un buen servicio nuestra tarea esencial</strong></p>
                            <p>Nuestro objetivo es que se sientan <strong>respaldados</strong> en todo el proceso de compra, minimizar las incidencias o, cuando aparecen, resolverlas eficazmente, ofrecerles las herramientas necesarias para diseñar la mejor <strong>oferta de macetas y que las puedan presentar de forma sencilla</strong> y atractiva creando juntos una experiencia de compra satifactoria para el usuario final.</p>
                        </div>
                    </div>
                </div>

                <div className="nuestras-marcas">
                    <div className="titulo-principal">
                        <p>Nuestras marcas</p>
                        <DobleGuion />
                    </div>
                    <div className="fabricas">
                        <div className="deroma">
                            <div className="image">
                                <img src="/static/img/img-deroma.jpg" alt="" />
                            </div>
                            <div className="info">
                                <div className="titulo"><p>Deroma</p></div>
                                <div className="texto">
                                    <p>Nacida en Italia en 1955, en la región del Véneto, el grupo internacional Deroma es el grupo industrial más importante del mundo de las macetas para plantas y la decoración. El grupo Deroma cuenta con 6 filiales comerciales que cubren los más importantes mercados internacionales y 3 unidades productivas que son el corazón de la empresa donde se fabrican miles de macetas y se envían a mercados de todo el mundo cada día. Las certificaciones ISO 9001 e ISO14001 avalan, a su vez, el compromiso de Deroma con la calidad del producto y con el cuidado del medio ambiente.</p>
                                    <p className="enlace"><a href="http://www.deroma.com/">www.deroma.com</a></p>
                                </div>
                            </div>
                        </div>

                        <div className="scheurich">
                            <div className="image">
                                <img src="/static/img/img-scheurich.jpg" alt="" />
                            </div>
                            <div className="info">
                                <div className="titulo"><p>Scheurich</p></div>
                                <div className="texto">
                                    <p>Con alrededor de 500 empleados, el grupo alemán Scheurich desarrolla y fabrica macetas de interior desde hace más de 90 años, que se venden en más de 80 países, lo que convierten a Scheurich en el líder europeo en macetas de interior. Las macetas de Scheurich se caracterizan por sus colores de tendencia, sus diseños y formas innovadoras, por su garantía de impermeabilidad 100% y por el encaje perfecto de la maceta de cultivo en el cubre macetas. Las macetas de Scheurich se fabrican con materias de alta calidad siguiendo procesos de fabricación respetuosos con el medio ambiente con certificados ISO-14001 e ISO 50001.</p>
                                    <p className="enlace"><a href="https://www.scheurich.de/">www.scheurich.de</a></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div >
    )
}